import * as React from "react"
import Seo from "../components/seo"
// import Hero from "../components/sections/marketing/Hero";
// import MarketingServices from "../components/sections/marketing/MarketingServices";
import Hero from "../components/sections/movie-trailer/Hero"
import { Helmet } from "react-helmet"

const MovieTrailer = () => (
  <>
    <Seo title="Marketing Services" />
    <Helmet bodyAttributes={{ class: "header-class movie-trailer-page" }} />
    <Hero />
  </>
)

export default MovieTrailer
